import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from "@headlessui/react";
import { useAxiosInstance } from "../../../services/Interceptor";
import { deleteOfferAction } from "../../../store/AthleteActions";
import { useDispatch } from "react-redux";

export default function DeleteOffer({
  deleteOfferOpen,
  closeDeleteOffer,
  offerId,
}) {
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();

  const deleteAccolade = () => {
    dispatch(deleteOfferAction(apiInstance, offerId));
    closeDeleteOffer();
  };

  return (
    <Dialog
      open={deleteOfferOpen}
      onClose={closeDeleteOffer}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-800/50 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg shadow-lg">
          <div className="p-6">
            <DialogTitle className="text-lg font-semibold mb-4">
              Delete Offer?
            </DialogTitle>
            <form>
              <p className="mb-4 text-sm text-gray-600 pb-3">
                {" "}
                Are you sure you want to delete the selected offer?
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={closeDeleteOffer}
                  className="px-4 py-2 rounded border"
                >
                  Cancel
                </button>
                <button
                  onClick={deleteAccolade}
                  className="px-4 py-2 bg-red-600 text-white rounded"
                >
                  Delete
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
